import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tabsContent" }
const _hoisted_2 = { class: "max330" }
const _hoisted_3 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_4 = { class: "topCard" }
const _hoisted_5 = { class: "cardName" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_trash" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "cardContent" }
const _hoisted_10 = { class: "cardNumber" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("sup", null, "**** **** ****", -1)
const _hoisted_12 = { class: "cardDate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.cards.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("payments.no_cards")), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cardWrapper",
          key: card.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(card.custom_name), 1),
            _createElementVNode("a", {
              href: "#",
              class: "deleteCard",
              onClick: ($event: any) => (_ctx.deleteCard(card))
            }, _hoisted_8, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(card.last_four_digits), 1)
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(card.expiration_month) + "/" + _toDisplayString(card.expiration_year), 1)
          ]),
          _createElementVNode("span", {
            class: _normalizeClass([_ctx.getCardIcon(card), "cardNetwork"])
          }, null, 2)
        ]))
      }), 128))
    ])
  ]))
}